<template>
    <div id="submission-page" class="home-wrapper">
        <div class="flex1" id="comments-submission-page">
            <!--<submission-channel-header></submission-channel-header>-->

            <div class="h-content" style="width:100%;">
                <div class="col-full padding-bottom-1 flex1">
                    <nsfw-warning
                            v-if="submission.nsfw == 1 && !Store.settings.feed.include_nsfw_submissions"
                            :text="'This submission contains NSFW content which can not be displayed according to your personal settings.'"
                    ></nsfw-warning>

                    <div v-if="submission.nsfw == 0 || Store.settings.feed.include_nsfw_submissions">
                        <loading v-if="loadingSubmission"></loading>

                        <full-submission v-if="!loadingSubmission" :list="submission" :full="true"></full-submission>

                        <section class="box-typical comments">
                            <div class="box-typical-inner ui threaded comments">
                                <header class="comments-header" v-if="actionType !== 'create'">
                                    <el-button type="primary"
                                               @click="writeComment(0, null)">
                                        Write a comment
                                    </el-button>
                                </header>

                                <comment-form style="border-top: none !important;"
                                        v-if="actionType === 'create'"
                                        :show-serious-button="submission.typeSubmission === 'serious'"
                                        :submission="submission.id"
                                        :commentors="commentors"
                                        :currentCommentId="currentCommentId"
                                        :activeComment="activeComment"
                                        :actionType="actionType"
                                        :key="actionType + currentCommentId"
                                ></comment-form>
                            </div>
                        </section>

                        <section class="box-typical comments"
                                 v-if="showSeriousCommentsSection"
                                 id="serious">
                            <div class="box-typical-inner ui threaded comments" v-if="submission.id != 0">
                                <header class="comments-header">
                                    <div>Serious Comments</div>
                                    <!--<el-button type="primary"
                                               @click="writeComment('serious', null)">
                                        Write a serious comment
                                    </el-button>-->
                                </header>

                                <!--<comment-form
                                        v-if="currentCommentId === 'new'"
                                        :show-serious-button="submission.typeSubmission === 'serious'"
                                        :submission="submission.id"
                                        :commentors="commentors"
                                        :currentCommentId="currentCommentId"
                                        :activeComment="activeComment"
                                        :actionType="actionType"
                                        :key="actionType + currentCommentId"
                                ></comment-form>-->

                                <!--                 <span class="simple-loading" v-if="loadingComments && page < 2">
                                                  <i class="el-icon-loading"></i>
                                                </span> -->

                                <comment
                                        style=""
                                        :list="d"
                                        :comments-order="commentsOrder"
                                        v-for="d in seriousList"
                                        v-if="seriousList.length"
                                        :key="d.id"
                                        :full="true"
                                        :commentors="commentors"
                                        :currentCommentId="currentCommentId"
                                        :activeComment="activeComment"
                                        :actionType="actionType"
                                ></comment>
                            </div>
                        </section>

                        <section class="box-typical comments" v-if="showRelaxedCommentsSection" id="relaxed">
                            <div class="box-typical-inner ui threaded comments" v-if="submission.id != 0">
                                <header class="comments-header">
                                    <div>Relaxed Comments</div>
                                    <!--<el-button
                                            type="primary"
                                            @click="writeComment('relaxed', null)"
                                    >Write a relaxed comment
                                    </el-button>-->
                                </header>

                                <!--<comment-form
                                        v-if="currentCommentId === 'relaxed'"
                                        :submission="submission.id"
                                        :type="'relaxed'"
                                        :commentors="commentors"
                                        :currentCommentId="currentCommentId"
                                        :activeComment="activeComment"
                                        :actionType="actionType"
                                        :key="actionType + currentCommentId"
                                ></comment-form>-->

                                <span class="simple-loading" v-if="loadingComments && page < 2">
                                  <i class="el-icon-loading"></i>
                                </span>

                                <comment
                                        style=""
                                        :list="c"
                                        :comments-order="commentsOrder"
                                        v-for="c in uniqueList"
                                        v-if="uniqueList.length"
                                        :key="c.id"
                                        :full="true"
                                        :commentors="commentors"
                                        :currentCommentId="currentCommentId"
                                        :activeComment="activeComment"
                                        :actionType="actionType"
                                ></comment>
                            </div>
                        </section>

                        <section v-if="showNoCommentsBox" class="box-typical comments">
                            <div class="box-typical-inner ui threaded comments">
                                <span class="no-comments-yet">No comments here yet. Care to be the first one?</span>
                            </div>
                        </section>

                        <div class="align-center margin-bottom-1" v-if="moreComments">
                            <el-button
                                    round
                                    plain
                                    class="half-width margin-top-1"
                                    @click="loadMoreComments"
                                    :loading="loadingComments"
                            >Load More Comments
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FullSubmission from "../components/FullSubmission.vue";
    import Comment from "../components/Comment.vue";
    import CommentForm from "../components/CommentForm.vue";
    import ChannelHeader from "../components/ChannelHeader.vue";
    import SubmissionChannelHeader from "../components/SubmissionChannelHeader.vue";
    import Loading from "../components/Loading.vue";
    import NsfwWarning from "../components/NsfwWarning.vue";
    import Helpers from "../mixins/Helpers";

    export default {
        props: {
            url: {
                type: String,
                default: ''
            }
        },
        mixins: [Helpers],

        components: {
            FullSubmission,
            Comment,
            CommentForm,
            Loading,
            ChannelHeader,
            SubmissionChannelHeader,
            NsfwWarning
        },

        data() {
            return {
                page: 1,
                moreComments: false,
                loadingComments: true,
                activeName: "all",

                comments: [],
                serious: [],
                sort: "hot",
                onlineUsers: [],

                showFormSerious: false,
                showFormRelax: false,

                currentCommentId: 0,
                activeComment: null,
                actionType: "create"
            };
        },
        mounted() {
            setTimeout(() => {
                this.initZoom()
            }, 1000)
        },

        created() {
            if (!!this.url) {
                let slug = this.url.split('/').pop()
                Store.page.submission
                    .getSubmission(slug)
                    .then(() => {
                        this.getComments();
                        this.listen();
                        this.setPageTitle(this.submission.title);
                    })
            } else {
                this.getComments();
                this.listen();
                this.setPageTitle(this.submission.title);
            }


            this.$eventHub.$on("newComment", this.newComment);

            this.$eventHub.$on("cancelComment", comment => {
                this.actionType = "create";
                this.currentCommentId = 0;
                this.activeComment = null;
            });

            this.$eventHub.$on("patchedComment", comment => {
                this.actionType = "create";
                this.currentCommentId = 0;
                this.activeComment = null;
            });

            this.$eventHub.$on("reply-comment", comment => {
                this.actionType = "reply";
                this.currentCommentId = comment.id;
                this.activeComment = comment;
            });
            this.$eventHub.$on("edit-comment", comment => {
                this.actionType = "edit";
                this.currentCommentId = comment.id;
                this.activeComment = comment;
            })

        },

        beforeDestroy() {
            this.$eventHub.$off("newComment", this.newComment);

            Store.page.submission.clearSubmission();
        },

        watch: {
            $route() {
                this.clear();
                this.getComments();
                this.listen();
                this.$eventHub.$on("newComment", this.newComment);
                this.setPageTitle(this.submission.title);
            }
        },

        computed: {
            commentors() {
                return _.map(this.comments, "author");
            },
            type() {
                return this.actionName;
            },

            submission() {
                return Store.page.submission.submission;
            },

            loadingSubmission() {
                return Store.page.submission.loadingSubmission;
            },

            onlineUsersCount() {
                return this.onlineUsers.length;
            },

            uniqueList() {
                let unique = [];
                let temp = [];

                this.comments.forEach(function (element, index, self) {
                    if (temp.indexOf(element.id) === -1) {
                        unique.push(element);
                        temp.push(element.id);
                    }
                });

                return unique;
            },
            seriousList() {
                let unique = [];
                let temp = [];

                this.serious.forEach(function (element, index, self) {
                    if (temp.indexOf(element.id) === -1) {
                        unique.push(element);
                        temp.push(element.id);
                    }
                });

                return unique;
            },

            /**
             * The order that comments should be printed with
             *
             * @return string
             */
            commentsOrder() {
                return this.sort == "hot" ? "rate" : "created_at";
            },

            showSeriousCommentsSection() {
              return !this.loadingSubmission && this.submission.typeSubmission === 'serious' && this.seriousList.length
            },

            showRelaxedCommentsSection() {
              return !this.loadingSubmission && this.uniqueList.length
            },

            showNoCommentsBox() {
              if (this.loadingSubmission)
                return false
              if (this.showSeriousCommentsSection || this.showRelaxedCommentsSection)
                return false
              return this.submission.id != 0
            }
        },

        methods: {
            writeComment(current, active) {
                if (!!this.auth.id) {
                    this.currentCommentId = current;
                    this.actionType = 'create';
                    this.activeComment = active;
                } else {
                    this.mustBeLogin();
                }
            },

            clear() {
                this.moreComments = false;
                this.page = 1;
                this.comments = [];
            },
            handleClick() {
                this.getComments();
            },

            loadMoreComments() {
                this.page++;
                this.getComments();
            },

            /**
             * receives the broadcasted comment.
             *
             * @return void
             */
            newComment(comment) {
                this.currentCommentId = 0;
                this.actionType = "create"
                this.activeComment = null;
                if (
                    comment.parent_id != null ||
                    comment.submission_id != this.submission.id
                )
                    return;

                // add broadcasted (used for styling)
                if (comment.user_id != auth.id) {
                    comment.broadcasted = true;
                }

                if (comment.type === "serious") {
                    this.serious.unshift(comment);
                } else {
                    this.comments.unshift(comment);
                }
                this.submission.comments_count++;

                if (comment.user_id == auth.id) {
                    this.$nextTick(function () {
                        document.getElementById("comment" + comment.id).scrollIntoView();
                    });
                }
            },

            /**
             * listen for broadcasted comments
             *
             * @return void
             */
            listen() {
                const channelAddress = "submission." + this.$route.params.slug;

                Echo.channel(channelAddress)
                    .listen("CommentWasCreated", event => {
                        this.$eventHub.$emit("newComment", event.data);
                    })
                    .listen("CommentWasPatched", event => {
                        this.$eventHub.$emit("patchedComment", event.data);
                    })
                    .listen("CommentWasDeleted", event => {
                        this.$eventHub.$emit("deletedComment", event.data);
                    });

                // we can't do presence channel or/and listen for private channels, if the user is a guest
                if (this.isGuest) return;

                Echo.join(channelAddress)
                    .here(users => {
                        this.onlineUsers = users;
                    })
                    .joining(user => {
                        this.onlineUsers.push(user);
                    })
                    .leaving(user => {
                        let index = this.onlineUsers.indexOf(user.username);
                        this.onlineUsers.splice(index, 1);

                        // if typer loses his connection for any reason, we $emit "finished-typing" because
                        // after all, we must make sure other users won't see "@user is typing" forever!
                        this.$eventHub.$emit("finished-typing", user.username);
                    });
            },

            /**
             * get comments
             *
             * @return void
             */
            getComments() {
                this.loadingComments = true;

                axios
                    .get(`/submissions/${this.submission.id}/comments`, {
                        params: {
                            page: this.page,
                            sort: this.sort,
                            with_children: true,
                            with_parent: true,
                            type: this.activeName
                        }
                    })
                    .then(response => {
                        this.loadingComments = false;

                        if (this.activeName == "relaxed") {
                            this.comments.push(...response.data.relaxed);
                            this.serious = [];
                        }
                        if (this.activeName == "serious") {
                            this.serious.push(...response.data.serious);
                            this.comments = [];
                        }
                        if (this.activeName === "all") {
                            this.comments.push(...response.data.relaxed);
                            this.serious.push(...response.data.serious);
                        }

                        if (response.data.links.next != null) {
                            this.moreComments = true;
                        } else {
                            this.moreComments = false;
                        }
                    })
                    .catch(error => {
                        this.loadingComments = false;
                    });
            },

            newSort(sort) {
                if (sort == this.sort) return;

                this.clear();
                this.getComments();
                this.sort = sort;
            }
        }
    };
</script>
<style scoped>
    .comments {
        background: #ffffff;
        padding: 1px;
        margin: 20px 0;
    }

    .fixed-comment-form-wrapper {
        padding: 1em 1em;
    }

    .humtog_c_s .is-top {
        margin-left: 5px;
        margin-bottom: 0px !important;
    }

    .humtog_c_s {
        margin-top: 20px;
        /* border-top: 2px solid #C0C4CC; */
        /* border-left: 2px solid #C0C4CC; */
        /* border-right: 2px solid #C0C4CC; */
        background: #fff;
    }

    .comments-header {
        font-size: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px;
    }

    .home-wrapper {
        height: auto !important;
    }


    @media (max-width: 600px) {
        button.el-button.el-button--primary {
            font-size: 10px;
            padding: 8px;
        }
        header.comments-header {
            font-size: 12px;
            font-weight: bold;
        }

        i.el-tooltip.v-icon.margin-left-1.v-bookmark {
            display: none;
        }

        .replycomment {
            padding-left: 2px !important;
            padding-right: 15px !important;
            font-size: 10px;
        }
        .submission-title {
            font-size: 16px;
        }

        p {
            font-size: 12px !important;
        }
        .info {
            font-size: 10px;
        }
        .htudvm {
            width: 90px !important;
            font-size: 10px;
            padding: 5px;
        }

        .dbtm{
            font-size: 10px !important;
        }
        .el-button--mini.is-round {
            padding: 3px 8px;
            font-size: 10px;
        }
    }
</style>
<style>

    .submission-box > .el-dialog > .el-dialog__header {
        -webkit-box-shadow: none;
        box-shadow: none;
        padding-bottom: 0;
        padding: 0;
    }

    .submission-box > .el-dialog > .el-dialog__header > .el-dialog__headerbtn {
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 0;
        background: #1e1d1d;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 24px;
        font-weight: bold;
        z-index: 10;
    }

    .submission-box > .el-dialog {
        top: 8vh;
        max-width: 1300px;
        background-color: rgb(244, 245, 247);
    }

    .ck .ck-balloon-panel {
        z-index: 9999 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/SubmissionPageContent.vue